import React from "react";
import "../styles/PaymentResult.scss";
import icon_checkbox from "../../assets/images/check-box.svg";
import icon_errorbox from "../../assets/images/error-box.svg";
import { useParams } from "react-router-dom";

const PaymentResult = () => {
  const { status } = useParams();

  return (
    <div id="PaymentResult">
      {status === "success" ? (
        <>
          <div className="title-wrapper">
            <img src={icon_checkbox} alt="complete" style={{ width: 24, height: 24 }} />
            <h1>Payment has been completed</h1>
          </div>
          <p>Please return to Aetherium and check your My NFTs.</p>
          <button
            onClick={() => {
              try {
                window.close();
              } catch (err) {
                window.open("/shop?tab=My-NFTs");
              }
            }}
          >
            Return to Aetherium
          </button>
        </>
      ) : status === "fail" ? (
        <>
          <div className="title-wrapper">
            <img src={icon_errorbox} alt="complete" style={{ width: 24, height: 24 }} />
            <h1>Payment failed</h1>
          </div>
          <p>Please return to Aetherium and try the payment again.</p>
          <button
            onClick={() => {
              try {
                window.close();
              } catch (err) {
                window.open("/shop?tab=Shop");
              }
            }}
          >
            Return to Aetherium
          </button>
        </>
      ) : (
        <div>Page Not Found</div>
      )}
    </div>
  );
};

export default PaymentResult;
